import { Grid } from "@mui/material";
import { LocaleContext } from "../../../routing/LangRouter";
import { useContext } from "react";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";

//import styles
import "./mobile-header.scss";

function MobileHeader({ title, details, edit, skip, justifyContent, isButton, handleClick }) {
    const { locale } = useContext(LocaleContext);

    return (
        <Grid
            className="mobile-header"
            container
            item
            xs={12}
            justifyContent="space-between"
            alignItems="center"
            display={{ xs: "flex", md: "none" }}
        >
            <Grid container item xs={isButton ? 2.5 : 1}>
                {locale === "en" ? (
                    <ArrowLeft2 size="24" color="var(--teal-color-18)" variant="Outline" onClick={handleClick} />
                ) : (
                    <ArrowRight2 size="24" color="var(--teal-color-18)" variant="Outline" onClick={handleClick} />
                )}
            </Grid>

            <Grid container item xs={isButton ? 5 : 10} columnGap={3} justifyContent={justifyContent} alignItems="center">
                <Grid container item xs="auto" direction="column">
                    <span className="mobile-header__title">{title}</span>
                    <span className="mobile-header__details">
                        <bdi>{details}</bdi>
                    </span>
                </Grid>
                <Grid className={`${edit ? "mobile-header__edit" : ""}`} container item xs="auto" alignItems="center">
                    {edit}
                </Grid>
            </Grid>

            <Grid container item xs={isButton ? 2.5 : 1} justifyContent="flex-end">
                {skip}
            </Grid>
        </Grid>
    );
}

export default MobileHeader;
